// extracted by mini-css-extract-plugin
module.exports = {"filter":"styles_filter__3mHDD","block":"styles_block__i1Fcg"};